export default __webpack_public_path__ + "static/8-388b7b7c199c5c3f2058ead295397bf0.webp";